import React from 'react';
import { Mail, MessageSquare, MessageCircle } from 'lucide-react';

import { EMessageChannel } from 'src/services/api';

type Props = {
    channel: EMessageChannel;
    /** Icon size in px, matching lucide's `size` prop. */
    size?: number;
    className?: string;
}

/**
 * The icon vocabulary for messaging channels, shared by the inbox list and the
 * conversation view so a channel always looks the same everywhere in the app.
 */
export default function ChannelIcon({ channel, size = 20, className }: Props) {
    switch (channel) {
        case EMessageChannel.EMAIL:
            return <Mail size={size} className={className} />;
        case EMessageChannel.SMS:
            return <MessageSquare size={size} className={className} />;
        case EMessageChannel.FACEBOOK_MESSENGER:
            return <MessageCircle size={size} className={className} />;
        default: {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const _assertNever: never = channel;
            return null;
        }
    }
}
